import {Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {IonContent, ModalController, Platform} from '@ionic/angular';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {BxhComponent} from './bxh/bxh.component';
import {LspComponent} from './lsp/lsp.component';
import {Subscription} from 'rxjs';
import {LscComponent} from './lsc/lsc.component';
import {TkpComponent} from './tkp/tkp.component';
import {HdComponent} from './hd/hd.component';
import {ScreenOrientation} from '@ionic-native/screen-orientation/ngx';
import {WstxcbService} from '../service/wstxcb.service';
import {AccountService} from '../service/account.service';
import {HelperService} from "../service/helper.service";
import {CustomNumberService} from "../service/custom-number.service";
import {HttpResponse} from "@angular/common/http";
import {ApiService} from "../service/api.service";
import {TranslateConfigService} from "../service/translate-config.service";

@Component({
  selector: 'app-txcb',
  templateUrl: './txcb.component.html',
  styleUrls: ['./txcb.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('displayBoxChat', [
      state('leave', style({
        opacity: '0',
        transform: 'scale(0.7)'
      })),
      state('show', style({
        opacity: '1',
        transform: 'scale(1)'
      })),
      state('hidden', style({
        display: 'none'
      })),
      transition('leave => show', animate('200ms cubic-bezier(0.36, 0.66, 0.04, 1.3)')),
      transition('show => leave', animate('700ms cubic-bezier(0.36, 0.66, 0.04, 1.6)'))
    ]),
    trigger('moneyBetting', [
      state('zoomIn', style({
        transform: 'scale(1.07)'
      })),
      state('zoomOut', style({
        transform: 'scale(1)'
      })),
      transition('zoomIn => zoomOut', animate('150ms ease-in-out')),
      transition('zoomOut => zoomIn', animate('150ms ease-in-out'))
    ]),
    trigger('timerCountdown', [
      state('zoomIn', style({
        transform: 'scale(1.07)'
      })),
      state('zoomOut', style({
        transform: 'scale(1)'
      })),
      transition('zoomIn => zoomOut', animate('150ms ease-in-out')),
      transition('zoomOut => zoomIn', animate('150ms ease-in-out'))
    ]),
    trigger('finishTimerCount', [
      state('zoomIn', style({
        transform: 'scale(1.1)'
      })),
      state('zoomOut', style({
        transform: 'scale(1)'
      })),
      transition('zoomIn => zoomOut', animate('150ms ease-in-out')),
      transition('zoomOut => zoomIn', animate('150ms ease-in-out'))
    ]),
    trigger('alertGame', [
      state('hide', style({
        opacity: '0',
        transform: 'translateY(-20px)',
      })),
      state('show', style({
        opacity: '1',
        transform: 'translateY(0)',
      })),
      transition('hide => show', animate('300ms ease-in')),
      transition('show => hide', animate('300ms ease-out'))
    ]),
    trigger('alertMoneyWin', [
      state('hide', style({
        opacity: '0',
        transform: 'translateY(20px)',
      })),
      state('show', style({
        opacity: '1',
        transform: 'translateY(0)',
      })),
      transition('hide => show', animate('300ms ease-in')),
      transition('show => hide', animate('300ms ease-out'))
    ]),
    trigger('alertMoneyRefund', [
      state('hide', style({
        opacity: '0',
        transform: 'translateY(20px)',
      })),
      state('show', style({
        opacity: '1',
        transform: 'translateY(0)',
      })),
      transition('hide => show', animate('300ms ease-in')),
      transition('show => hide', animate('300ms ease-out'))
    ])
  ]
})
export class TxcbComponent implements OnInit, OnDestroy {
  @ViewChild('elListChat', {static: false}) elListChat: ElementRef;
  @ViewChild('elBoxChat', {static: false}) elBoxChat: ElementRef;
  @ViewChild('resultBottom', {static: false}) elResultBottom: ElementRef;
  @ViewChild(IonContent, {static: false}) content: IonContent;
  @ViewChild('plateCount', {static: false}) elPlateCount: ElementRef;
  @ViewChild('wrapGameTXCB', {static: false}) elWrapGameTXCB: ElementRef;

  @ViewChild('plateClose', {static: false})
  set plateClose(content: ElementRef) {
    if (content) {
      const getPosiPlateCount = this.elPlateCount.nativeElement.getBoundingClientRect();
      const circle2 = {
        x: getPosiPlateCount.x,
        y: getPosiPlateCount.y,
        radius: 30
      };
      let currentX, currentY, activeMove = false, initialX, initialY, xOffset = 0, yOffset = 0;
      content.nativeElement.addEventListener('touchstart', (event) => {
        initialX = event.touches[0].clientX - xOffset;
        initialY = event.touches[0].clientY - yOffset;
        activeMove = true;
      });

      content.nativeElement.addEventListener('mousedown', (event) => {
        initialX = event.clientX - xOffset;
        initialY = event.clientY - yOffset;
        activeMove = true;
      });

      let onceCall = 0;
      content.nativeElement.addEventListener('touchmove', (event) => {
        const elTarget = event.target;
        if (activeMove) {
          currentX = event.touches[0].clientX - initialX;
          currentY = event.touches[0].clientY - initialY;
          xOffset = currentX;
          yOffset = currentY;
          elTarget.style.transform = `translate3d(${currentX}px, ${currentY}px, 0)`;
          const getPosiPlateClose = content.nativeElement.getBoundingClientRect();
          const circle1 = {
            x: getPosiPlateClose.x,
            y: getPosiPlateClose.y,
            radius: 30
          };
          if (!this.collideCircle(circle1, circle2)) {
            onceCall += 1;
            if (onceCall === 1) {
              elTarget.style.transition = 'all .4s ease-out';
              elTarget.style.opacity = 0;
              setTimeout(() => {
                this.isPlateClose = false;
                if (!this.isOpenedWin) {
                  this.openWin();
                }
              }, 410);
            }
          }
        }
      });

      content.nativeElement.addEventListener('mousemove', (event) => {
        const elTarget = event.target;
        if (activeMove) {
          currentX = event.clientX - initialX;
          currentY = event.clientY - initialY;
          xOffset = currentX;
          yOffset = currentY;
          elTarget.style.transform = `translate3d(${currentX}px, ${currentY}px, 0)`;
          const getPosiPlateClose = content.nativeElement.getBoundingClientRect();
          const circle1 = {
            x: getPosiPlateClose.x,
            y: getPosiPlateClose.y,
            radius: 30
          };
          if (!this.collideCircle(circle1, circle2)) {
            onceCall += 1;
            if (onceCall === 1) {
              elTarget.style.transition = 'all .4s ease-out';
              elTarget.style.opacity = 0;
              setTimeout(() => {
                this.isPlateClose = false;
                if (!this.isOpenedWin) {
                  this.openWin();
                }
              }, 410);
            }
          }
        }
      });

      content.nativeElement.addEventListener('touchend', (event) => {
        initialX = currentX;
        initialY = currentY;
        activeMove = false;
      });

      content.nativeElement.addEventListener('mouseup', (event) => {
        initialX = currentX;
        initialY = currentY;
        activeMove = false;
      });
    }
  }

  valMoneyBetTai = 0;
  valMoneyBetXiu = 0;
  timerCount = '00';
  isTimerCount = true;
  timeInterVal = null;
  coutUserTai = 0;
  coutUserXiu = 0;
  moneyCountTai = 0;
  moneyCountXiu = 0;
  isMoneyTai = true;
  isMoneyXiu = true;
  moneyConfirmTai = 0;
  moneyConfirmXiu = 0;
  showBoxChat = 'leave';
  showSuggestChat = 'leave';
  arrowToggleChat = 'down';
  effectMoneyTaiBetting = 'zoomOut';
  effectMoneyXiuBetting = 'zoomOut';
  effectFinishTimerCount = 'zoomOut';
  effectTimerCountdown = 'zoomOut';
  effectMoneyWin = 'hide';
  effectMoneyRefund = 'hide';
  isHotTimerCount = false;
  isDiceJump = false;
  posiEffectDice = 0;
  isHasResult = false;
  posiDiceResult1 = 1;
  posiDiceResult2 = 1;
  posiDiceResult3 = 1;
  isFinishTimerCount = false;
  finishTimerCount = '';
  isResultTai = false;
  isResultXiu = false;

  timeoutEffectDiceJump = null;
  timeoutMoneyWin = null;
  timeoutMoneyRefund = null;

  moneyBetting = [
    {
      txt: '1K',
      val: 1000
    },
    {
      txt: '10K',
      val: 10000
    },
    {
      txt: '50K',
      val: 50000
    },
    {
      txt: '100K',
      val: 100000
    },
    {
      txt: '500K',
      val: 500000
    },
    {
      txt: '1M',
      val: 1000000
    },
    {
      txt: '5M',
      val: 5000000
    },
    {
      txt: '10M',
      val: 10000000
    }
  ];
  issue = '00000';
  paramsWSBet = {taixiuId: 0, userId: 0, loginname: '', betamount: 0, typed: 0, userType: 0, betfrom: 0}; // betfrom = 0 PC, betfrom = 1 Android, betfrom = 2 IOS, betfrom = 3 WAP
  userInfo = null;
  isTimerCountBetFinish = false;
  currMoneyTaiBetting = 0;
  currMoneyXiuBetting = 0;
  moneyWin = 0;
  moneyRefund = 0;
  subscription: Subscription[] = [];
  subscriptionOpenWin: Subscription;
  subscriptionCountdown: Subscription;
  subscriptionScreenOri: Subscription;
  balance = 0;
  msg = '';
  timeOutValRandChat = null;
  listHisPhien = [];
  toggleHandPlate = false;
  isPlateClose = false;
  isEffectPlaceClose = false;
  isLandscape = false;
  modalTKPhien = null;
  isMaintain = false;

  checkIsNextPhien = false;
  isOpenedWin = false;

  isMuted = false;
  objAudioBg: any;

  subscriptionBalance: Subscription;

  constructor(
    private modalCtr: ModalController,
    private wstxcbService: WstxcbService,
    public accountService: AccountService,
    private hpService: HelperService,
    private screenOrientation: ScreenOrientation,
    public platform: Platform,
    private apiService: ApiService,
    private translateConfigService: TranslateConfigService,
    private customNumber: CustomNumberService
  ) {
    this.wstxcbService.sendMessage(this.hpService.MINI_MSG_LSP_TX, {});
    this.wstxcbService.sendMessage(this.hpService.MINI_MSG_PUBLIC_TX, {});
    setTimeout(_ => {
      this.wstxcbService.sendMessage(this.hpService.MINI_MSG_LSP_TX, {});
      this.moneyConfirmTai = this.moneyConfirmXiu = 0;
      this.currMoneyTaiBetting = this.currMoneyXiuBetting = 0;
    }, 2000);

    this.objAudioBg = new Audio('../../assets/txcb/audio/tx_bg.mp3');
    this.playAudio(this.objAudioBg, true);

    platform.ready().then((readySource) => {
      this.detectScreenOrient();

    });
    this.subscriptionScreenOri = screenOrientation.onChange().subscribe(
      () => {
        this.detectScreenOrient();
      }
    );
    this.subscription.push(this.subscriptionScreenOri);
  }

  detectScreenOrient() {
    setTimeout(() => {
      const pH = this.platform.height();
      const pW = this.platform.width();
      let hGame = 0;
      if (pW > pH) {
        this.isLandscape = true;
        hGame = 332;
      } else if (pW < pH) {
        this.isLandscape = false;
        hGame = 549;
      }

      if (pH < hGame) {
        this.elWrapGameTXCB.nativeElement.style.transform = `scale(${(pH / hGame)})`;
      } else {
        this.elWrapGameTXCB.nativeElement.style.transform = `scale(1)`;
      }
    }, 100);
  }

  collideCircle(circle1, circle2) {
    const distanceX = circle1.x - circle2.x;
    const distanceY = circle1.y - circle2.y;
    const radiiSum = circle1.radius + circle2.radius;
    return distanceX * distanceX + distanceY * distanceY <= radiiSum * radiiSum;
  }

  ngOnInit() {

    this.paramsWSBet.loginname = localStorage.getItem('ur');
    this.paramsWSBet.userType = 0;

    const getHisBet = this.wstxcbService.objHisBet;
    if (getHisBet && getHisBet.bt > 0) {
      this.moneyConfirmTai = getHisBet.bt;
      this.isMoneyTai = false;
    } else if (getHisBet && getHisBet.bx > 0) {
      this.moneyConfirmXiu = getHisBet.bx;
      this.isMoneyXiu = false;
    }

    //topic balance
    this.subscriptionBalance = this.hpService.getObserverBalance().subscribe(body => {
      this.balance = body.rs;
    });
    this.subscription.push(this.subscriptionBalance);

    // topic/tx => public
    this.subscriptionCountdown = this.hpService.getObserverGameTXCB().subscribe(body => {
      // START flag maintain
      if (body.cmd === 12 && body.rs) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-game-maintain')});
        this.isMaintain = true;
      }
      // END flag maintain

      // START countdown 50s
      if (body.cmd === 1) {
        if (body.cd == 50) {
          this.moneyConfirmTai = this.moneyConfirmXiu = 0;
        }
        this.issue = this.paramsWSBet.taixiuId = body.id;
        this.coutUserTai = body.ut;
        this.coutUserXiu = body.ux;
        this.moneyCountTai = body.at;
        if (this.currMoneyTaiBetting < this.moneyCountTai) {
          this.currMoneyTaiBetting = this.moneyCountTai;
          this.effectMoneyTaiBetting = 'zoomIn';
          setTimeout(() => {
            this.effectMoneyTaiBetting = 'zoomOut';
          }, 160);
        }
        this.moneyCountXiu = body.ax;
        if (this.currMoneyXiuBetting < this.moneyCountXiu) {
          this.currMoneyXiuBetting = this.moneyCountXiu;
          this.effectMoneyXiuBetting = 'zoomIn';
          setTimeout(() => {
            this.effectMoneyXiuBetting = 'zoomOut';
          }, 160);
        }
        if (body.cd <= 10) {
          this.isHotTimerCount = true;
          this.effectTimerCountdown = 'zoomIn';
          setTimeout(() => {
            this.effectTimerCountdown = 'zoomOut';
          }, 160);
        } else {
          this.isHotTimerCount = false;
        }
        if (body.cd < 10) {
          this.timerCount = `0${body.cd}`;
        } else {
          this.timerCount = `${body.cd}`;
        }
        body.cd < 2 ? this.isTimerCountBetFinish = true : this.isTimerCountBetFinish = false;
        this.isResultTai = this.isDiceJump = this.isHasResult = this.isResultXiu = this.isFinishTimerCount = false;
        this.isTimerCount = true;
        const elEffectDotResult = this.elResultBottom.nativeElement.querySelector('i');
        if (elEffectDotResult) {
          elEffectDotResult.remove();
        }

        this.isPlateClose = false;
        this.isOpenedWin = false;
      }
      // END countdown 50s

      // START trả tiền cân chửa
      if (body.cmd === 1 && body.cd === 0) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-door-balance')});

        // START show money can bang
        body.at > body.ax ? this.moneyCountTai = this.moneyCountXiu = body.ax : this.moneyCountXiu = this.moneyCountTai = body.at;
        // END show money can bang

        this.effectMoneyTaiBetting = this.effectMoneyXiuBetting = 'zoomIn';
        setTimeout(() => {
          this.effectMoneyTaiBetting = this.effectMoneyXiuBetting = 'zoomOut';
        }, 160);
      }
      // END trả tiền cân chửa

      // START return result dice and effect dice jump
      if (body.cmd === 5 && body.cd === -1) {
        this.listHisPhien.unshift({id: body['id'], result: body['rs']});
        this.listHisPhien.pop();
        this.hpService.observableHisPhienTXCB.next(this.listHisPhien);
        this.effectDiceJump(body.rs);
      }
      // END return result dice and effect dice jump

      // START countdown finish issue
      if (body.cmd === 2 && body.cd <= 14) {

        if (this.isMaintain && body.cd === 10) {
          this.isMaintain = false;
          this.closeGame();
          return;
        }
        if (body.cd === 2) {
          this.getUserInfo();
        }

        setTimeout(() => {
          this.isFinishTimerCount = true;
        }, 200);

        this.initModalHasResult(body);

        if (body.cd < 10) {
          this.finishTimerCount = `0${body.cd}`;
        } else {
          this.finishTimerCount = `${body.cd}`;
        }
        let onceCall = 0;
        if (body.cd < 3) {
          onceCall++;
          if (this.isPlateClose && onceCall === 1) {
            setTimeout(() => {
              this.isPlateClose = false;
              if (!this.isOpenedWin) {
                this.openWin();
              }
            }, 410);
          }
        }

        this.effectFinishTimerCount = 'zoomIn';
        setTimeout(() => {
          this.effectFinishTimerCount = 'zoomOut';
        }, 160);
        if (body.cd === 0) {
          if (this.isPlateClose) {
            this.isOpenedWin = true;
            this.appendDotResult();
          }
          this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-start-new-turn')});
          this.moneyConfirmTai = this.moneyConfirmXiu = 0;
          this.currMoneyTaiBetting = this.currMoneyXiuBetting = 0;
          this.wstxcbService.objHisBet = {bt: null, bx: null};
        }

        if (body.cd === 10) {
          this.hpService.observableIsValidNextTKPTXCB.next({flag: 'reloadTkP', issueNew: this.issue});
        }
      }
      this.checkIsNextPhien = false;
      if (body.cmd === 2 && body.cd <= 17) {
        this.checkIsNextPhien = true;
      }
      // END countdown finish issue

      // START chat responsive
      if (body.cmd === 10) {
        this.appendNewLineChat({u: body.u, msg: body.m.trim()});
      }
      // END chat responsive

      // START check valid next tkPhien
      if (body.cmd === 1 || body.cmd === 2) {
        this.hpService.observableIsValidNextTKPTXCB.next('checkNextTKPhien');
      }
      // END check valid next tkPhien
    });
    this.subscription.push(this.subscriptionCountdown);

    // user/queue/tx => only user
    this.subscriptionOpenWin = this.wstxcbService.receiveMessageQueueTX().subscribe(wsData => {
      const body = JSON.parse(wsData.body);

      // START betting
      if (body.cmd === 3) {
        let error = false;
        let msg = '';
        let isLockedError = false;
        if (body.status === 0) {
          this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-success-bet')});
          this.getUserInfo();
          if (!this.isMoneyTai) {
            this.moneyConfirmTai += this.valMoneyBetTai;
            this.valMoneyBetTai = 0;
            this.wstxcbService.objHisBet = {bt: this.moneyConfirmTai, bx: 0};
          } else if (!this.isMoneyXiu) {
            this.moneyConfirmXiu += this.valMoneyBetXiu;
            this.valMoneyBetXiu = 0;
            this.wstxcbService.objHisBet = {bt: 0, bx: this.moneyConfirmXiu};
          }
        } else if (body.status === 8) {
          if (this.valMoneyBetXiu > 0 && !this.isMoneyXiu) {
            msg = this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-bet-tai');
          } else if (this.valMoneyBetTai > 0 && !this.isMoneyTai) {
            msg = this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-bet-xiu');
          }
          error = true;
        } else if (body.status === 1 && !this.isTimerCount) {
          error = true;
          msg = this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-turn-not-start');
        } else if (body.status === 1 && this.isTimerCount) {
          error = true;
          msg = this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-time-out');
        } else if (body.status === 99) {
          error = true;
          msg = this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-system-error');
        } else if (body.status === 13) {
          error = true;
          msg = this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-invalid-money');
        } else if (body.status === 14) {
          error = true;
          msg = 'Nhằm đảm bảo sự an toàn của tài khoản，mời quý khách đăng nhập lại vào tài khoản sau đó đổi mật khẩu trước khi đặt cược!';
        } else if (body.status === 15) {
          error = true;
          msg = this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-account-lock');
        } else if (body.status === 30) {
          error = true;
          msg = 'Tài khoản đại lý không thể đặt cược';
        } else if (body.status === 16) {
          error = true;
          msg = this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-invalid-balance');
        } else if (body.status === 12) {
          error = true;
          isLockedError = true;
          msg = 'Bạn đã bị chặn cược trò chơi này, vui lòng liên hệ CSKH!';
        } else if (body.status === 10) {
          error = true;
          msg = this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-min-max-money');
        }

        if (error && msg !== '') {
          if (!isLockedError) {
            this.valMoneyBetTai = this.valMoneyBetXiu = 0;
            this.hpService.observableAlertMiniGame.next({msg});
          } else {
            this.hpService.observableAlertMiniGame.next({msg, delayTime: 4500});
          }
        }
      }
      // END betting

      // START return money win if has betting
      if (body.cmd === 4 && body.amount > 0) {
        this.moneyWin = body.amount;
        if (this.moneyWin > 0) {
          console.info(this.moneyWin);
          this.getUserInfo();
        }

        // this.getUserBlance();
      }
      // END return money win if has betting

      // START history phien
      if (body.cmd === 6) {
        this.listHisPhien = body.data;
        const listDotHisPhien: Array<any> = this.listHisPhien.filter((item, idx) => idx < 14).reverse();
        let htmlDotHisPhien = '';
        this.elResultBottom.nativeElement.innerHTML = '';

        listDotHisPhien.forEach((item, idx) => {
          const rsA = JSON.parse(item['result']);
          const clsDot = (rsA[0] + rsA[1] + rsA[2]) < 11 ? 'dotXiu' : 'dotTai';
          const el = `<span class="dotResult ${clsDot}">${rsA[0] + rsA[1] + rsA[2]}</span>`;
          htmlDotHisPhien += el;
        });
        this.elResultBottom.nativeElement.innerHTML = htmlDotHisPhien;
      }
      // END history phien

      // START refund money
      if (body.cmd === 7 && body.amount > 0) {
        this.moneyRefund = body.amount;
        if (this.moneyRefund > 0) {
          console.info(this.moneyRefund);
          this.getUserInfo();
        }

        this.effectMoneyRefund = 'show';
        // this.getUserBlance();
        this.timeoutMoneyRefund = setTimeout(() => {
          this.effectMoneyRefund = 'hide';
          setTimeout(() => {
            this.moneyRefund = 0;
          }, 110);
        }, 2000);
      }
      // END refund money

      // START get total bet
      if (body.cmd === 13) {
        const moneyBet = Number(body.rs.split(':')[0]);
        const getTyped = body.rs.split(':')[1];
        getTyped === '1' ? this.moneyConfirmTai = moneyBet : this.moneyConfirmXiu = moneyBet;
      }
      // END get total bet

      // START chat list history
      if (body.cmd === 11) {
        const arrChatHis = [];
        body.data.forEach(item => {
          arrChatHis.push({u: item.u, msg: item.m.trim(), status: 1});
        });
        const arrChat = arrChatHis;

        let htmlChat = '';
        arrChat.forEach(item => {
          htmlChat += `<div class="txtChat"><span>${item.u}:</span>${item.msg}</div>`;
        });
        this.elListChat.nativeElement.innerHTML = htmlChat;
        setTimeout(() => {
          this.content.scrollToBottom().then(r => {
          });
        });
      }
      // END chat list history

      // START block chat user
      if (body.cmd === 10) {
        if (body.rs) {
          this.appendNewLineChat({u: '', msg: body.rs, status: 0});
        }
      }
      // END block chat user
    });
    this.subscription.push(this.subscriptionOpenWin);
  }

  ngOnDestroy(): void {
    this.objAudioBg.pause();
    clearInterval(this.timeInterVal);
    clearTimeout(this.timeoutMoneyWin);
    clearTimeout(this.timeoutMoneyRefund);
    this.subscription.forEach(subscription => {
      if (subscription !== null) {
        subscription.unsubscribe();
      }
    });
    clearTimeout(this.timeOutValRandChat);
    //  this.hpService.observableAlertTXCB.next({msg: 'closeGame'});
  }

  ionViewWillEnter() {
    this.getUserInfo();
  }

  appendNewLineChat(item: { u: string, msg: string, status?: number }) {
    // START remove el txt chat first
    const elTxtChatFirst = this.elListChat.nativeElement.querySelectorAll('.txtChat');
    if (elTxtChatFirst && elTxtChatFirst.length > 0) {
      this.elListChat.nativeElement.querySelectorAll('.txtChat')[0].remove();
    }
    // END remove el txt chat first

    // START add element txt chat
    const elTxtChat = document.createElement('div');
    elTxtChat.classList.add('txtChat');
    if (item.status === 0) {
      elTxtChat.classList.add('errorChat');
    }
    elTxtChat.innerHTML = `<span>${item.u}:</span>${item.msg}`;
    this.elListChat.nativeElement.appendChild(elTxtChat);
    // END add element txt chat

    this.content.scrollToBottom(250).then(r => {
    });
  }

  initModalHasResult(body) {
    if (body.rs && !this.toggleHandPlate) {
      this.issue = this.paramsWSBet.taixiuId = body.id;
      this.isTimerCount = false;
      this.isHasResult = this.isDiceJump = true;
      this.posiDiceResult1 = body.rs[0];
      this.posiDiceResult2 = body.rs[1];
      this.posiDiceResult3 = body.rs[2];
      this.coutUserTai = body.ut;
      this.coutUserXiu = body.ux;

      //   this.effectResultTxt();

      // START show money can bang
      body.at > body.ax ? this.moneyCountTai = this.moneyCountXiu = body.ax : this.moneyCountXiu = this.moneyCountTai = body.at;
      // END show money can bang
    }
  }

  ionViewDidEnter() {
    this.showBoxChat = 'show';
  }

  toggleInputMoney(event, flag) {
    event.preventDefault();
    this.playAudio('../../assets/txcb/audio/tx_select.mp3');
    setTimeout(() => {
      this.valMoneyBetXiu = this.valMoneyBetTai = 0;
      if (flag === 'tai') {
        this.isMoneyTai = false;
        this.isMoneyXiu = true;
      } else if (flag === 'xiu') {
        this.isMoneyXiu = false;
        this.isMoneyTai = true;
      }
    }, 100);
  }

  async closeGame() {
    await this.modalCtr.dismiss();
  }

  effectDiceJump(arrayDice) {
    this.playAudio('../../assets/txcb/audio/tx_dice.mp3');

    this.isDiceJump = true;
    this.isTimerCount = false;
    this.isEffectPlaceClose = true;

    // spritesheet dice effect
    const interValDiceJump = setInterval(() => {
      this.posiEffectDice += 1;
    }, 66);

    // timeout dice effect
    this.timeoutEffectDiceJump = setTimeout(() => {
      clearInterval(interValDiceJump);
      this.posiEffectDice = 0;
      this.isDiceJump = false;
      this.isHasResult = true;
      this.isEffectPlaceClose = false;

      // START show result Dices
      this.posiDiceResult1 = arrayDice[0];
      this.posiDiceResult2 = arrayDice[1];
      this.posiDiceResult3 = arrayDice[2];
      // END show result Dices

      if (this.toggleHandPlate) {
        this.isPlateClose = true;
      } else {
        this.openWin();
      }

    }, 3000);
  }

  openWin() {
    this.playAudio('../../assets/txcb/audio/tx_dice_final.mp3');

    this.effectResultTxt();
    this.effectMoneyWinUser();
    this.appendDotResult();

    this.hpService.observableReloadHisBet.next('reloadHisBet');

    // this.getUserInfo();
  }

  effectMoneyWinUser() {
    if (this.moneyWin > 0) {
      this.playAudio('../../assets/txcb/audio/tx_win.mp3');
      this.effectMoneyWin = 'show';
      this.timeoutMoneyWin = setTimeout(() => {
        this.effectMoneyWin = 'hide';
        setTimeout(() => {
          this.moneyWin = 0;
        }, 310);
      }, 5000);
    }
  }

  effectResultTxt() {
    if (this.posiDiceResult1 + this.posiDiceResult2 + this.posiDiceResult3 <= 10) {
      this.isResultTai = false;
      this.isResultXiu = true;
    } else {
      this.isResultTai = true;
      this.isResultXiu = false;
    }
  }

  appendDotResult() {
    const elDotResultFirst = this.elResultBottom.nativeElement.querySelectorAll('.dotResult');
    if (elDotResultFirst && elDotResultFirst.length > 0) {
      this.elResultBottom.nativeElement.querySelectorAll('.dotResult')[0].remove();
    }
    const elDotResultNew = document.createElement('span');
    if (this.isPlateClose) {
      elDotResultNew.innerHTML = `${this.posiDiceResult1 + this.posiDiceResult2 + this.posiDiceResult3}`;
    } else {
      elDotResultNew.innerHTML = `<i></i>${this.posiDiceResult1 + this.posiDiceResult2 + this.posiDiceResult3}`;
    }
    const clsDotResult = (this.posiDiceResult1 + this.posiDiceResult2 + this.posiDiceResult3) > 10 ? 'dotTai' : 'dotXiu';
    elDotResultNew.classList.add('dotResult', `${clsDotResult}`);
    this.elResultBottom.nativeElement.appendChild(elDotResultNew);
  }

  selectMoneyBetting(event, item) {
    this.playAudio('../../assets/txcb/audio/tx_select.mp3');
    event.preventDefault();
    if (!this.isMoneyXiu) {
      this.valMoneyBetXiu += item.val;
    } else if (!this.isMoneyTai) {
      this.valMoneyBetTai += item.val;
    } else {
      this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-choose-tx')});
    }
  }

  cancelBetting(event) {
    event.preventDefault();
    this.playAudio('../../assets/txcb/audio/tx_select.mp3');
    this.valMoneyBetTai = this.valMoneyBetXiu = 0;
    this.isMoneyTai = this.isMoneyXiu = true;
  }

  preventBetClick = false;
  betting(event) {
    event.preventDefault();
    if (!this.preventBetClick) {
      this.preventBetClick = true;
      setTimeout(() => {
        this.preventBetClick = false;
      }, 200);
      this.playAudio('../../assets/txcb/audio/tx_bet.mp3');
      if (this.checkIsNextPhien) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-turn-not-start')});
        return;
      }
      if (this.isMoneyTai && this.isMoneyXiu) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-choose-tx')});
        return;
      } else if (this.valMoneyBetTai === 0 && this.valMoneyBetXiu === 0) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-please-bet-money')});
        return;
      }
      if (this.valMoneyBetTai > 0) {
        this.paramsWSBet.typed = 1;
        this.paramsWSBet.betamount = this.valMoneyBetTai;
      } else if (this.valMoneyBetXiu > 0) {
        this.paramsWSBet.typed = 2;
        this.paramsWSBet.betamount = this.valMoneyBetXiu;
      }
      // if (this.hpService.isMobileWebAndroid || this.hpService.isMobileWebIOS) {
      //     this.paramsWSBet.betfrom = 3;
      // } else if (this.hpService.isDeviceAndroid) {
      //     this.paramsWSBet.betfrom = 1;
      // } else if (this.hpService.isDeviceIOS) {
      //     this.paramsWSBet.betfrom = 2;
      // }

      if (this.paramsWSBet.betamount === null || this.paramsWSBet.betamount <= 0) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-invalid-money')});
        return;
      }
      if (this.paramsWSBet.betamount > this.balance) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-invalid-balance')});
        return;
      }
      if (this.paramsWSBet.betamount < 1000) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-min-money')});
        return;
      }
      if (this.paramsWSBet.betamount % 1000 !== 0) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-round-money')});
        return;
      }
      this.wstxcbService.sendMessage(this.hpService.MINI_MSG_BET_TX, this.paramsWSBet);
    }
  }

  allInBetting(event) {
    event.preventDefault();
    if (!this.preventBetClick) {
      this.preventBetClick = true;
      setTimeout(() => {
        this.preventBetClick = false;
      }, 200);
      this.playAudio('../../assets/txcb/audio/tx_bet.mp3');
      if (this.isMoneyTai && this.isMoneyXiu) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-choose-tx')});
        return;
      }
      this.valMoneyBetXiu = this.valMoneyBetTai = 0;
      if (this.valMoneyBetXiu >= this.balance || this.valMoneyBetTai >= this.balance) {
        return;
      }
      if (!this.isMoneyXiu) {
        this.valMoneyBetXiu += Math.floor(this.balance / 1000) * 1000;
      } else if (!this.isMoneyTai) {
        this.valMoneyBetTai += Math.floor(this.balance / 1000) * 1000;
      }
    }
  }

  toggleBoxChat(event) {
    event.preventDefault();
    if (this.showBoxChat === 'hidden') {
      this.showBoxChat = 'leave';
      setTimeout(() => {
        this.wstxcbService.sendMessage(this.hpService.MINI_MSG_PUBLIC_TX, {});
        this.showBoxChat = 'show';
      }, 210);
    } else if (this.showBoxChat === 'show') {
      this.showBoxChat = 'leave';
      setTimeout(() => {
        this.showBoxChat = 'hidden';
      }, 410);
    }
  }

  audio(event) {
    event.preventDefault();
    this.isMuted = !this.isMuted;
    if (this.isMuted) {
      this.objAudioBg.pause();
    } else {
      this.playAudio(this.objAudioBg, true);
    }
  }

  bxhTXCB(event) {
    event.preventDefault();

    this.hpService.observableLoading.next(true);
    this.apiService.getRankTX().subscribe(
      data => {
        this.modalBXHTXCB(data).then(() => {
          this.hpService.observableLoading.next(false);
        });
      },
      error => {
        console.log(error);
        this.hpService.observableLoading.next(false);
      },
      () => {
      }
    );
  }

  async modalBXHTXCB(data) {
    const modal = await this.modalCtr.create({
      component: BxhComponent,
      // enterAnimation: enterModalAnimation,
      // leaveAnimation: leaveModalAnimation,
      cssClass: 'modalTXCBBet',
      mode: 'md',
      componentProps: {
        dataBxh: data
      }
    });
    return await modal.present();
  }

  hdTXCB(event) {
    event.preventDefault();
    this.modalHDTXCB().then(() => {
      this.hpService.observableLoading.next(false);
    });
  }

  async modalHDTXCB() {
    const modal = await this.modalCtr.create({
      component: HdComponent,
      cssClass: 'modalTXCBBet',
      mode: 'md',
    });
    return await modal.present();
  }

  hisBet(event) {
    event.preventDefault();

    this.hpService.observableLoading.next(true);
    this.apiService.getHisBetTX(0).subscribe(
      (data: HttpResponse<any>) => {
        this.modalLSCTXCB(data).then(() => {
          this.hpService.observableLoading.next(false);
        });
      },
      error => {
        console.log(error);
        this.hpService.observableLoading.next(false);
      },
      () => {
      }
    );
  }

  async modalLSCTXCB(data) {
    const modal = await this.modalCtr.create({
      component: LscComponent,
      cssClass: 'modalTXCBBet',
      mode: 'md',
      componentProps: {
        dataHis: data
      }
    });
    return await modal.present();
  }

  hisPhien(event) {
    event.preventDefault();
    this.modalLSPTXCB().then(() => {
      this.hpService.observableHisPhienTXCB.next(this.listHisPhien);
    });
  }

  async modalLSPTXCB() {
    const modal = await this.modalCtr.create({
      component: LspComponent,
      // enterAnimation: enterModalAnimation,
      // leaveAnimation: leaveModalAnimation,
      cssClass: 'modalTXCBBet',
      mode: 'md'
    });
    return await modal.present();
  }

  tkPhien(event) {
    event.preventDefault();
    let txID = 0;
    if (Number(this.timerCount) > 0) {
      txID = Number(this.issue) - 1;
    } else {
      txID = Number(this.issue);
    }

    this.hpService.observableLoading.next(true);
    this.apiService.thongKePhienTX(txID).subscribe(
      data => {
        this.modalTKPTXCB(data, txID).then(() => {
          this.hpService.observableLoading.next(false);
        });
      },
      error => {
        console.log(error);
        this.hpService.observableLoading.next(false);
      },
      () => {
      }
    );
  }

  async modalTKPTXCB(data, prevIssue) {
    this.modalTKPhien = await this.modalCtr.create({
      component: TkpComponent,
      // enterAnimation: enterModalAnimation,
      // leaveAnimation: leaveModalAnimation,
      cssClass: 'modalTXCBBet',
      mode: 'md',
      componentProps: {
        dataTKP: data,
        txID: prevIssue
      }
    });
    return await this.modalTKPhien.present();
  }

  toggleHand(event) {
    event.preventDefault();
    this.toggleHandPlate = !this.toggleHandPlate;
  }

  sendChat(event) {
    event.preventDefault();
    /* if (this.balance < 20000) {
       this.appendNewLineChat({u: '', msg: 'Số dư của bạn phải trên 20,000 để có thể chat!', status: 0});
     } else*/
    if (this.msg !== '' && this.msg.length <= 120) {
      this.wstxcbService.sendMessage(this.hpService.MINI_MSG_CHAT_TX, {u: this.userInfo.login, m: this.msg});
    } else {
      this.appendNewLineChat({
        u: '',
        msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-invalid-message'),
        status: 0
      });
    }
    this.msg = '';
  }

  toggleSuggestChat() {
    if (this.showSuggestChat === 'leave') {
      this.showSuggestChat = 'show';
      this.arrowToggleChat = 'up';
    } else {
      this.showSuggestChat = 'leave';
      this.arrowToggleChat = 'down';
    }
  }

  getUserBlance() {
    this.apiService.getUserBalance().subscribe(
      res => {

        if (res.body.status === this.hpService.ERROR_CODE_SUCCESS) {
          this.balance = this.customNumber.balanceNum(res.body.data);
        } else {
          this.hpService.handleError(res.body.message);
        }
      });

  }

  getUserInfo() {
    this.apiService.getUserInfoData({}).subscribe(
      res => {
        if (res.status === this.hpService.ERROR_CODE_SUCCESS) {
          this.balance = this.customNumber.balanceNum(res.data.balance);
          this.userInfo = {
            id: res.data.id,
            login: res.data.login,
            balance: res.data.balance
          };
        } else {
          this.hpService.handleError(res.message);
        }
      });

  }

  playAudio(audioSource: any, loop = false) {
    if (!this.isMuted) {
      let objAudio: any;
      if (loop) {
        objAudio = audioSource;
      } else {
        objAudio = new Audio(audioSource);
      }
      objAudio.pause();
      objAudio.currentTime = 0;
      objAudio.play();
      objAudio.loop = loop;
    }
  }

}
